import { StandardEvents } from '@shopify/events';

/**
 * <cmp-variant-sync data-block-id="...">
 * Keeps a variant-dependent Liquid block up to date when the variant changes.
 * Horizon's variant picker fetches the updated section HTML and dispatches a
 * product select event on the section; this element swaps its own content with
 * the matching element (same data-block-id) from that HTML.
 */
class CmpVariantSync extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  /** @param {Event & { promise?: Promise<any> }} event */
  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;
        const next = html.querySelector(`cmp-variant-sync[data-block-id="${this.dataset.blockId}"]`);
        if (next) this.innerHTML = next.innerHTML;
      })
      .catch(() => {});
  };
}

if (!customElements.get('cmp-variant-sync')) {
  customElements.define('cmp-variant-sync', CmpVariantSync);
}
